import { ComponentConfig } from '@measured/puck';

import { Text, TextSize, TextWeight } from '../../../../components/atoms/text/text';

type ListBlockProps = {
  text: {
    item: React.ReactNode | string;
  }[];
  orderType: 'ordered' | 'unordered';
  size?: TextSize;
  weight?: TextWeight;
};

const ListBlock: ComponentConfig<ListBlockProps> = {
  label: 'List',
  fields: {
    text: {
      type: 'array',
      arrayFields: {
        item: { type: 'text' },
      },
    },
    orderType: {
      type: 'radio',
      options: [
        { label: 'Ordered', value: 'ordered' },
        { label: 'Unordered', value: 'unordered' },
      ],
    },
    size: {
      type: 'radio',
      options: [
        { label: 'Extra Small', value: 'xs' },
        { label: 'Small', value: 'sm' },
        { label: 'Medium', value: 'md' },
        { label: 'Large', value: 'lg' },
      ],
    },
    weight: {
      type: 'radio',
      options: [
        { label: 'Normal', value: 'normal' },
        { label: 'Semibold', value: 'semibold' },
        { label: 'Bold', value: 'bold' },
      ],
    },
  },
  defaultProps: {
    text: [{ item: 'This is generic text' }, { item: 'This is more generic text' }],
    orderType: 'unordered',
    weight: 'normal',
    size: 'md',
  },
  render: ({ text, orderType, weight, size }) => {
    const ListTag = orderType === 'ordered' ? 'ol' : 'ul';
    const listStyleClass = orderType === 'ordered' ? 'list-decimal' : 'list-disc';

    return (
      <ListTag className={`${listStyleClass} pl-6`}>
        {text.map((t, i) => (
          <Text key={typeof t.item === 'string' ? t.item : i} size={size} tag="li" weight={weight}>
            {t.item}
          </Text>
        ))}
      </ListTag>
    );
  },
};

export { ListBlock };
export type { ListBlockProps };
